import React from 'react';

class PowerIconLarge extends React.Component {
  render() {
    return (
      <svg
        width="82"
        height="82"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M13 13V1H11V13H13Z" fill="#8A8B8D" />
        <path
          d="M3 12C3 8.67 4.80801 5.76109 7.50073 4.20344L6.49927 2.47223C3.21398 4.37267 1 7.9272 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 7.9272 20.786 4.37267 17.5007 2.47223L16.4993 4.20344C19.192 5.76109 21 8.67 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
          fill="#8A8B8D"
        />
      </svg>
    );
  }
}

export default PowerIconLarge;
